import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

function formatFlagToIST(flag) {
  const tabMatch = flag.match(/tab_switch_during_Q(\d+)_at_(.+)/);
  const pasteMatch = flag.match(/paste_attempt_during_Q(\d+)_at_(.+)/);

  let type, question, timestamp;
  if (tabMatch) {
    type = 'Tab Switch';
    question = tabMatch[1];
    timestamp = tabMatch[2];
  } else if (pasteMatch) {
    type = 'Paste Attempt';
    question = pasteMatch[1];
    timestamp = pasteMatch[2];
  } else {
    return flag;
  }

  const date = new Date(timestamp);
  const istTime = date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  return `${type} on Question ${question} at ${istTime} IST`;
}

function ExamComplete() {
  const { slug } = useParams();
  const location = useLocation();
  const submission = location.state?.submission;
  const cheatFlags = location.state?.cheatFlags || submission?.cheatFlags || [];

  if (!submission) {
    return (
      <div className="exam-page">
        <div className="exam-container">
          <div className="exam-card completion-card">
            <div className="completion-icon">&#10003;</div>
            <h1>Exam Submitted</h1>
            <p>Your exam has been submitted. Thank you for participating.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="exam-page">
      <div className="exam-container">
        <div className="exam-card completion-card">
          <div className="completion-icon icon-pass">&#10003;</div>
          <h1>Exam Submitted Successfully</h1>
          <p className="completion-subtitle">Thank you for completing the exam.</p>

          <div className="results-box">
            <div className="result-item">
              <span className="result-label">Questions Answered</span>
              <span className="result-value">
                {submission.answers
                  ? `${submission.answers.filter(a => (a.answer || '').trim() !== '').length} / ${submission.answers.length}`
                  : 'N/A'}
              </span>
            </div>
            <div className="result-item">
              <span className="result-label">Submitted At</span>
              <span className="result-value">
                {submission.submittedAt
                  ? new Date(submission.submittedAt).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: true, day: 'numeric', month: 'short', year: 'numeric' }) + ' IST'
                  : 'Just now'}
              </span>
            </div>
          </div>

          {cheatFlags.length > 0 && (
            <div className="cheat-notice">
              <h3>Integrity Notice</h3>
              <p>{cheatFlags.length} integrity flag(s) were recorded during your exam session.</p>
              <ul>
                {cheatFlags.map((flag, i) => (
                  <li key={i}>{formatFlagToIST(flag)}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="thank-you-message">
            <p>Your answers have been recorded successfully.</p>
            <p>You may now close this window.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExamComplete;
